import { Injectable } from "@angular/core";
import { OrderEsFactory } from "@edp-models/ES/es-order.model";
import { OrderEsService } from "@edp-services/ES/order-es.service";
import { EOrderEsActions, GetOrderEs, SetOrderAPIError, SetOrderEs } from "@edp-store/actions/ES/order-es.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";

@Injectable()
export class OrderEsEffects {
    @Effect()
    loadOrder$ = this.actions$.pipe(
        ofType(EOrderEsActions.GetOrderEs),
        switchMap((action: GetOrderEs) =>
            this.orderEsService.getOrder(action.contractId).pipe(
                mergeMap(order => of(new SetOrderEs(OrderEsFactory.create({ ...order, contractId: action.contractId })))),
                catchError((error: Error) => of(new SetOrderAPIError(error)))
            )
        )
    );

    constructor(private actions$: Actions, private orderEsService: OrderEsService) {}
}
